export default __webpack_public_path__ + "static/media/grouping.312867e4.svg";